const getAugmentedPhoneNumbers = function (state, getters) {
  const possibleTollFree = [
    'tollFree',
    'tollfree',
    'toll free',
    'Toll Free',
    'Tollfree',
  ]

  function checkIfTollFree(phoneNumber: string) {
    const numberMeta = state.locationTwilio?.numberMeta[phoneNumber]
    const tollFreeStatus = numberMeta?.tollFreeStatus || numberMeta?.status
    const tollFreeNumberType = possibleTollFree?.includes(
      numberMeta?.numberType
    )

    const tollFreeRegex = new RegExp(/^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/);

    return tollFreeRegex.test(phoneNumber) || tollFreeNumberType || tollFreeStatus
  }

  function evaluateTollFreeStatus(phoneNumber: string, sid: string) {
    const { status } = getters.getTollFreeData(sid, phoneNumber)
    return checkIfTollFree(phoneNumber) ? status : null
  }

  return function (collection: any[]) {
    const result = collection?.map(item => {
      const phoneNumber = item?.phoneNumber ?? item?.phone_number
      const sid = item?.sid

      item.client = {
        inHighLevelDB: Boolean(state.locationTwilio?.numbers[phoneNumber]),
        isDefaultOutboundNumber: Boolean(
          state.locationTwilio?.defaultOutboundNumber === phoneNumber
        ),
        isA2PVerified: Boolean(state.phoneNumbersA2PLookup[sid]),
        isTollFree: checkIfTollFree(phoneNumber),
        tollFreeStatus: evaluateTollFreeStatus(phoneNumber, sid),
        numberMeta: state.locationTwilio?.numberMeta[phoneNumber],
      }

      return item
    })

    return result
  }
}

export default getAugmentedPhoneNumbers
